//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from 'vuex'
import { axiosGet, axiosPost } from '../../axios/axios.js'
import { convertTime } from '../../components/helpers.js'

export default {
  props: {
    report: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      opened: false,

      hasBrigade: false,
      selectedEmployee: null,
      proposedEmployees: null,
      pagination: {
        rowsPerPage: 10,
        page: 1
      },
      columns: [
        {
          name: 'fio',
          label: 'ФИО',
          align: 'left',
          field: 'fio',
          classes: 'class-bordered',
          width: 250
        },
        {
          name: 'role',
          label: 'Роль',
          align: 'left',
          field: 'role',
          classes: 'class-bordered',
          width: 200
        },
        {
          name: 'startWorkTime',
          label: 'Время начала работы',
          align: 'left',
          field: 'startWorkTime',
          format: this.formatDateTime,
          classes: 'class-bordered',
          width: 200
        },
        {
          name: 'endWorkTime',
          label: 'Время завершения работы',
          align: 'left',
          field: 'endWorkTime',
          format: this.formatDateTime,
          classes: 'class-bordered',
          width: 200
        },
        {
          name: 'engineerScore',
          label: 'Инженерный уровень',
          align: 'left',
          field: 'engineerScore',
          classes: 'class-bordered',
          width: 150
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  methods: {
    formatDateTime: function (millis) {
      return convertTime(millis)
    },

    select: function (callback, post = false) {
      this.post = post
      this.callback = callback
      this.clearValue()

      if (this.proposedEmployees == null || post) {
        this.load(() => {
          this.hasBrigade = this.proposedEmployees.find(employee => employee.brigadeMember)
          this.opened = true
        })
      } else {
        this.hasBrigade = this.proposedEmployees.find(employee => employee.brigadeMember)
        this.opened = true
      }
    },
    confirm: function (selection) {
      if (this.post) {
        // Назначаем исполнителя
        const bodyFormData = new FormData()
        bodyFormData.set('report', this.report.id)
        bodyFormData.set('employee', JSON.stringify(this.getSelectedExecutorData(selection)))

        axiosPost({
          url: '/service/delta/report/assignImprovementEmployee',
          data: bodyFormData,
          onSuccess: () => {
            this.opened = false
            !!this.callback && this.callback(selection)
            this.clearValue()
          },
          onFailure: 'Ошибка назначения исполнителя',
          msgTarget: this
        })
      } else {
        this.opened = false
        !!this.callback && this.callback(selection)
        this.clearValue()
      }
    },
    close () {
      this.opened = false
      this.clearValue()
    },
    clearValue () {
      this.selectedEmployee = null
    },

    load: function (onSuccess) {
      this.$q.loading.show({ spinnerColor: 'blue-11' })
      const params = new URLSearchParams()
      params.set('id', this.report.id)

      axiosGet({
        url: '/service/delta/report/proposeImprovementEmployees?' + params.toString(),
        onSuccess: (response) => {
          this.$q.loading.hide()
          this.proposedEmployees = response.data.result.filter(employee => employee.responsible || employee.brigadier || employee.brigadeMember || employee.contractorDispatcher)
          if (this.proposedEmployees.length) {
            const responsibleEmployee = this.proposedEmployees.find(employee => employee.responsible)

            let defaultSelectedEmployee
            if (!responsibleEmployee) {
              defaultSelectedEmployee = {
                type: 'employee',
                value: this.proposedEmployees[0],
                valueKey: this.proposedEmployees[0].id
              }
            } else if (responsibleEmployee.brigadier) {
              const employees = this.proposedEmployees.filter(employee => employee.brigadier || employee.brigadeMember)
              defaultSelectedEmployee = {
                type: 'list',
                value: employees,
                valueKey: employees.map(employee => employee.id).join(',')
              }
            } else {
              defaultSelectedEmployee = {
                type: 'employee',
                value: responsibleEmployee,
                valueKey: responsibleEmployee.id
              }
            }

            !!onSuccess && onSuccess(defaultSelectedEmployee)
          }
        },
        onFailure: 'Ошибка загрузки сотрудников',
        msgTarget: this
      })
    },
    getSelectedExecutorData: function (selectedEmployee = this.selectedEmployee) {
      let executorData
      if (selectedEmployee.type === 'list') {
        executorData = {}
        const hasResponsible = selectedEmployee.value.find(employee => employee.responsible) != null
        selectedEmployee.value.forEach(employee => {
          executorData[employee.id] = employee.responsible || !hasResponsible
        })
      } else {
        executorData = selectedEmployee.valueKey
      }
      return executorData
    },
    confirmSelf: function () {
      const selection = {
        type: 'self',
        value: this.user.employee ? this.user.employee : this.user,
        valueKey: this.user.employee ? this.user.employee.id : this.user.login
      }
      this.confirm(selection)
    },
    confirmEmployee: function () {
      const selection = {
        type: 'employee',
        value: this.selectedEmployee,
        valueKey: this.selectedEmployee.id
      }
      this.confirm(selection)
    },
    confirmBrigade: function () {
      const employees = this.proposedEmployees.filter(employee => employee.brigadier || employee.brigadeMember)
      const selection = {
        type: 'list',
        value: employees,
        valueKey: employees.map(employee => employee.id).join(',')
      }
      this.confirm(selection)
    },
    onEmployeeSelect: function (employee) {
      this.selectedEmployee = employee
    },
    getEmployeeRole: function (employee) {
      if (employee.brigadier) {
        return 'Бригадир'
      } else if (employee.brigadeMember) {
        return 'Член бригады'
      } else if (employee.contractorDispatcher) {
        return 'Диспетчер Подрядчика'
      }
      return 'Сотрудник в офисе'
    }
  }
}
